var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: " ic/menu"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.26449 8H26.7352C27.4312 8 28.0005 8.56933 28.0005 9.26533V9.40133C28.0005 10.0973 27.4312 10.6667 26.7352 10.6667H5.26449C4.56849 10.6667 4.00049 10.0973 4.00049 9.40133V9.26533C4.00049 8.56933 4.56849 8 5.26449 8ZM26.7352 14.6666H5.26449C4.56849 14.6666 4.00049 15.236 4.00049 15.932V16.068C4.00049 16.764 4.56849 17.3333 5.26449 17.3333H26.7352C27.4312 17.3333 28.0005 16.764 28.0005 16.068V15.932C28.0005 15.236 27.4312 14.6666 26.7352 14.6666ZM26.7352 21.3334H5.26449C4.56849 21.3334 4.00049 21.9027 4.00049 22.5987V22.7347C4.00049 23.4307 4.56849 24 5.26449 24H26.7352C27.4312 24 28.0005 23.4307 28.0005 22.7347V22.5987C28.0005 21.9027 27.4312 21.3334 26.7352 21.3334Z",
    fill: "#1890FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.7a18bd879297c13c33b2fe6baf5b336f.svg";
export { ForwardRef as ReactComponent };